import type { FunctionComponent, ReactNode } from "react";

import { useModalContext } from "./modal-context";

export interface ModalComponent<Props> extends FunctionComponent<Props> {
  modalId: string;
}

export interface ModalComponentWithArgs<Props, _Args> extends ModalComponent<Props> {
  requiresModalArgs: true;
}

export const modal = <Props>(modalId: string, component: (props: Props) => ReactNode) => {
  const underlyingComponent = component as ModalComponent<Props>;

  underlyingComponent.modalId = modalId;

  return underlyingComponent;
};

export const modalWithArgs = <Props, Args>(modalId: string, component: (props: Props, args: Args) => ReactNode) => {
  const underlyingComponent = ((props: Props) => {
    const context = useModalContext();

    return component(props, context.args as Args);
  }) as ModalComponentWithArgs<Props, Args>;

  underlyingComponent.modalId = modalId;
  underlyingComponent.requiresModalArgs = true;

  return underlyingComponent;
};
